import { BASEURL } from '../../utilites';
import axios from 'axios';
import { CONFIG_ACTION_TYPE } from './Type';

// Function to get IP Address configuration
const getIpAddress = () => {
	return async (dispatch) => {
		dispatch({
			type: CONFIG_ACTION_TYPE.IP_ADDRESS_FETCHING_START,
		});
		// Fetch data and return promise
		return axios
			.get(`${BASEURL}/api/config/ip-address`)
			.then((response) => {
				const { data } = response.data;
				dispatch({
					type: CONFIG_ACTION_TYPE.IP_ADDRESS,
					payload: { data, status: true, error: '' },
				});
				return { data, status: true, error: '' };
			})
			.catch((error) => {
				// Handle any errors that occurred during the request
				const errorMessage = error?.response?.data?.error || error.message;
				dispatch({
					type: CONFIG_ACTION_TYPE.IP_ADDRESS,
					payload: { data: null, status: false, error: errorMessage },
				});
				console.error('Error fetching IP address:', error);
				return { data: null, status: false, error: errorMessage };
			});
	};
};

export const config = {
	getIpAddress,
};
